import * as swcHelpers from '@swc/helpers';
import CmsAccordion from './containers/Accordion/Accordion.js';
import Article from './containers/Article/Article.js';
import CmsBanner from './containers/Banner/Banner.js';
import CmsBannerCollection from './containers/BannerCollection/BannerCollection.js';
import BlogCollection from './containers/BlogCollection/BlogCollection.js';
import BlogOverview from './containers/BlogOverview/BlogOverview.js';
import BrandCollection from './containers/BrandCollection/BrandCollection.js';
import BrandList from './containers/BrandList/BrandList.js';
import Button from './containers/Button/Button.js';
import CmsCarousel from './containers/Carousel/Carousel.js';
import Document from './containers/Document/Document.js';
import Faq from './containers/Faq/Faq.js';
import Heading from './containers/Heading/Heading.js';
import IconList from './containers/IconList/IconList.js';
import CmsIframe from './containers/Iframe/Iframe.js';
import Newsletter from './containers/Newsletter/Newsletter.js';
import NewsletterBanner from './containers/NewsletterBanner/NewsletterBanner.js';
import NotificationBar from './containers/NotificationBar/NotificationBar.js';
import Olapic from './containers/Olapic/Olapic.js';
import CmsEmpty from './containers/Empty/Empty.js';
import PolicyBar from './containers/PolicyBar/PolicyBar.js';
import ProductCatalog from './containers/ProductCatalog/ProductCatalog.js';
import Promotion from './containers/Promotion/Promotion.js';
import RichText from './containers/RichText/RichText.js';
import CmsSeo from './containers/Seo/Seo.js';
import SpotlightedStores from './containers/SpotlightedStores/SpotlightedStores.js';
import CmsVideo from './containers/Video/Video.js';
import CmsWidget from './containers/Widget/Widget.js';
import RecentlyViewedProducts from './containers/RecentlyViewedProducts/RecentlyViewedProducts.js';
import TryInStoreBanner from './containers/TryInStoreBanner/TryInStoreBanner.js';
import GroupedCards from './containers/GroupedCards/GroupedCards.js';
import GlobalContactForm from './containers/GlobalContactForm/GlobalContactForm.js';
import CmsRow from './containers/RowComponent/Row/Row.js';
import CmsRowColumn from './containers/RowComponent/RowColumn/RowColumn.js';
import CmsRowImage from './containers/RowComponent/RowImage/RowImage.js';
import RowText from './containers/RowComponent/RowText/RowText.js';
import CmsRowVideo from './containers/RowComponent/RowVideo/RowVideo.js';
import RowProductListBySku from './containers/RowComponent/RowProductListBySku/RowProductListBySku.js';
import CmsRowTab from './containers/RowComponent/RowTab/RowTab.js';
import CmsRowPDPContainer from './containers/RowComponent/RowPDPContainer/RowPDPContainer.js';

const defaultComponentDefinitions = {
    Accordion: CmsAccordion,
    Article: Article,
    Banner: CmsBanner,
    'Banner collection': CmsBannerCollection,
    'Blog Collection': BlogCollection,
    'Blog Overview': BlogOverview,
    'Brand collection': BrandCollection,
    'Brand List': BrandList,
    'CTA Button': Button,
    Carousel: CmsCarousel,
    Document: Document,
    FAQ: Faq,
    Heading: Heading,
    'Icon-Link List': IconList,
    IFrame: CmsIframe,
    Newsletter: Newsletter,
    'Newsletter V2': NewsletterBanner,
    'Notification bar': NotificationBar,
    'Olapic Widget': Olapic,
    Page: CmsEmpty,
    'Policy bar': PolicyBar,
    'Product catalog v2': ProductCatalog,
    'Promotion Algolia': Promotion,
    Promotion: Promotion,
    'Rich Text': RichText,
    Seo: CmsSeo,
    'Spotlighted stores': SpotlightedStores,
    Translation: CmsAccordion,
    Video: CmsVideo,
    Widget: CmsWidget,
    'Recently viewed products': RecentlyViewedProducts,
    TryInStoreBanner: TryInStoreBanner,
    'Group Cards': GroupedCards,
    'Global Contact Form': GlobalContactForm,
    row: CmsRow,
    'row-1': CmsRow,
    'row-2': CmsRow,
    'row-3': CmsRow,
    'row-4': CmsRow,
    'row-5': CmsRow,
    'row-6': CmsRow,
    'row-7': CmsRow,
    'row-8': CmsRow,
    'row-9': CmsRow,
    'row-10': CmsRow,
    'row-11': CmsRow,
    'row-12': CmsRow,
    'row-13': CmsRow,
    'row-14': CmsRow,
    'row-15': CmsRow,
    'row-16': CmsRow,
    'row-17': CmsRow,
    'row-18': CmsRow,
    'row-19': CmsRow,
    'row-20': CmsRow,
    'column-wrapper-1': CmsRowColumn,
    'column-wrapper-2': CmsRowColumn,
    'column-wrapper-3': CmsRowColumn,
    'column-wrapper-4': CmsRowColumn,
    'Row component : Image': CmsRowImage,
    'Row component : Text': RowText,
    'Row component : Video': CmsRowVideo,
    'Row component : Product list by SKU': RowProductListBySku,
    'row-tabs-container': CmsRowTab,
    'row-pdp-container': CmsRowPDPContainer
};
function extendComponentDefinitions(definitionsToAdd) {
    return swcHelpers.objectSpread({}, defaultComponentDefinitions, definitionsToAdd);
}

export { defaultComponentDefinitions, extendComponentDefinitions };
//# sourceMappingURL=component-definitions.js.map
